import { render, staticRenderFns } from "./pre-registration.vue?vue&type=template&id=56841999&"
import script from "./pre-registration.vue?vue&type=script&lang=js&"
export * from "./pre-registration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports